"use client";
interface MobileVariantPageStickyNavProps {
  productTitle: string;
  formattedPrice: string;
  marketType: string
  marketStatus?: {
    percentDifference: number;
    isAboveMarket: boolean;
    dollarDifference: number;
  } | null
  onVariantsFilterClick?: () => void;
}

const MobileVariantPageStickyNav: React.FC<MobileVariantPageStickyNavProps> = ({
  productTitle,
  formattedPrice,
  marketType,
  marketStatus,
  onVariantsFilterClick,
}) => {

  const percentage = Math.abs(marketStatus?.percentDifference || 0);
  const aboveOrBelow = marketStatus?.isAboveMarket ? 'above' : 'below';
  const marketColor = marketType == "Sold" ? "text-maroon" : "text-sage-green" 


  return (
    <div className="flex flex-col w-full px-4">
      {/* Price - left aligned */}
      <div className="w-full flex justify-start pt-6">
        <div className="text-black text-[20px] font-raleway font-normal">
          {formattedPrice} | {productTitle}
        </div>
      </div>

      {/* Market Average Text - Left aligned */}
      {marketStatus && (
        <div className="w-full pt-3 pb-3">
          <span className="text-black text-sm font-raleway font-normal">Currently </span>
          <span className={`${marketColor} text-sm font-raleway font-normal`}>{percentage}% </span>
          <span className="text-black text-sm font-raleway font-normal">{aboveOrBelow} </span>
          <span className={`${marketColor} text-sm font-raleway font-normal`}>{marketType} Market Average </span>
        </div>
      )}

      {/* Variants Filter Button - Centered with proper styling */}
      {onVariantsFilterClick && (
        <div className="w-full pt-6 pb-6">
            <button
              onClick={onVariantsFilterClick}
              className="w-full px-3 py-2.5 bg-white border border-black flex justify-center items-center hover:bg-light-grey focus:bg-light-grey transition-colors"
            >
              <div className="text-center text-black text-sm font-raleway font-bold tracking-[1.6px]">
                VARIANTS FILTER
              </div>
            </button>
          </div>
      )}
    </div>
  );
};

export default MobileVariantPageStickyNav;